import { Button, Divider, Form, Input, Modal } from "antd";
import React, { useRef } from "react";
import ItemsService from "../../Services/ItemsService";
import { useClient } from "../../Context/ClientContext";
import { notificationContext } from "../../Common/PageRoute";
import { useMutation, useQueryClient } from "react-query";

const ItemLocationModel: React.FC<{
  open: boolean;
  onCancel: any;
  setTrigger: any;
  data?: any;
  setAddNewLocation?: any;
}> = (props) => {
  const autoCompleteRef = useRef<any>(null);
  const [form] = Form.useForm();
  const queryClient = useQueryClient();
  const { currentClient } = useClient();
  const { openNotification } = React.useContext(notificationContext);
  const [saveButtonLoading, setSaveButtonLoading] =
    React.useState<boolean>(false);

  // Post Api
  const postItem = () => {
    form.validateFields().then(async (value: any) => {
      setSaveButtonLoading(true);
      let data = {
        ...value,
      };

      await ItemsService.postItemLocation(
        data,
        currentClient?.id,
        props.data?.id
      )
        .then((res: any) => {
          if (res?.status) {
            // queryClient.invalidateQueries({
            //   queryKey: ["locations"],
            // });
            
            props?.setAddNewLocation && props?.setAddNewLocation(res?.result);
            openNotification(
              "success",
              `Item Location ${
                props.data?.id ? "updated successfully." : "added successfully."
              }`
            );
            props.onCancel();
            setSaveButtonLoading(false);
            props.setTrigger((x: boolean) => !x);
          } else {
            openNotification("error", res?.message);
            props.onCancel();
            setSaveButtonLoading(false);
            props.setTrigger((x: boolean) => !x);
          }

          // console.log(res);
        })
        .catch((ex: any) => {
          setSaveButtonLoading(false);
          openNotification("error", ex);
          console.error(ex);
        });
    });
  };

  // Get Api
  React.useEffect(() => {
    if (props?.data?.id) {
      form.setFieldsValue({ ...props?.data });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.data?.id]);

  // --------- InitialValues in Add Item Location Model ---------
  const initialValues = {};
  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (autoCompleteRef.current) {
        autoCompleteRef.current.focus();
      }
    }, 100); // Adjust delay if needed

    return () => clearTimeout(timer);
  }, []); // Ensures autofocus after initial render

  return (
    <div>
      <Modal
        open={props.open}
        title={props?.data?.id ? "Update Item Location" : "New Item Location"}
        width={"30%"}
        onCancel={() => props.onCancel()}
        style={{ maxHeight: `calc(100% - 100px)`, overflowY: "auto", top: 180 }}
        footer={
          <div style={{ marginTop: "0px" }}>
            <Button
              onClick={() => {
                form.resetFields();
                props.onCancel();
              }}
            >
              Cancel
            </Button>
            <Button
              className="modelSaveButtonMargin"
              type="primary"
              onClick={() => postItem()}
              loading={saveButtonLoading}
            >
              {!props?.data?.id ? "Save" : "Update"}
            </Button>
          </div>
        }
      >
        <Divider className="ca-model-css" />
        {/* <Spin indicator={antIcon} spinning={modelLoading}> */}
        <Form
          form={form}
          name="itemLocation"
          autoCapitalize="false"
          requiredMark={false}
          initialValues={initialValues}
          colon={false}
          labelAlign="left"
          labelCol={{ xs: 9, sm: 8 }}
          wrapperCol={{ xs: 16, sm: 16 }}
          labelWrap={true}
        >
          <Form.Item
            label="Item Location Name"
            name="itemLocationName"
            rules={[
              { required: true, message: "Item location's name is required" },
            ]}
            // className="input-item"
          >
            <Input
              placeholder="Item location's name"
              // onInput={(e: any) => {
              //   e.target.value = e.target.value.toUpperCase();
              // }}
              ref={autoCompleteRef}
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ItemLocationModel;
